import { M365ActualLightTheme } from "@m365-admin/customizations";
import { PartialPalette, PartialSemanticColors, PartialTheme, twoUIPaletteColors } from "../types";

export const familyPaletteColors = [
    ...twoUIPaletteColors
] as const;

// snapshotted on 2/25/2020 from https://www.figma.com/file/X2w9NdiyCKVvZwLYv8nnQ2/AMC-Fabric-POR?node-id=161%3A141
export const familyPalette: PartialPalette & { [K in typeof familyPaletteColors[number]]: string } = {
    themePrimary: "#047769",
    themeLighterAlt: "#f0faf8",
    themeLighter: "#c5e9e5",
    themeLight: "#98d6cf",
    themeTertiary: "#49aea2",
    themeSecondary: "#14887b",
    themeDarkAlt: "#036c60",
    themeDark: "#035b51",
    themeDarker: "#02433c",
    neutralLighterAlt: "#ececec",
    neutralLighter: "#e8e8e8",
    neutralLight: "#dedede",
    neutralQuaternary: "#c6c6c6",
    neutralQuaternaryAlt: "#cfcfcf",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#bebebe",
    neutralSecondary: "#6e6e6e",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    neutralMed: "#fafafa",
    neutralHigh: "#ffffff",
    transparent: "transparent",
    black: "#000000",
    white: "#f2f2f2",
    redDark: "#a4262c",
    redLight: "#feece5",
    highlighter: "#f8d22a"
};

export const familySemanticColors: PartialSemanticColors = {
    bodyBackground: familyPalette.white,
    navBackground: familyPalette.white,
    navItemBackgroundHovered: familyPalette.neutralLighter,
    navItemBackgroundPressed: familyPalette.neutralLight,
    severeWarning: "#fed9cc",
    errorBlockIcon: "#a80000",
    messageLink: familyPalette.themeDarkAlt,
    messageWebSuccess: "#107c10",
    warningIcon: "#901619",
    severeWarningIcon: "#790C0E",
    cautionYellow: "#9D5D00"
};

export const familyTheme: PartialTheme = {
    palette: familyPalette,
    semanticColors: familySemanticColors
};

export const familyLeftNavTheme: PartialTheme = {
    palette: familyPalette,
    semanticColors: {
        ...M365ActualLightTheme,
        ...familySemanticColors
    }
};
